export const isString = (t) => typeof t === 'string';
export const isBoolean = (t) => typeof t === 'boolean';
export const isNumber = (t) => typeof t === 'number';
export const isArray = (t) => Array.isArray(t) && t.every(isString);
const isValue = (t) => [isString, isBoolean, isNumber, isArray].some(fn => fn(t));
export const isRecord = (t) => typeof t === 'object' &&
    t !== null &&
    !(t instanceof Map) &&
    !(t instanceof Set) &&
    !Array.isArray(t) &&
    Object.values(t).every(isValue);
export const isValid = (t) => [isValue, isRecord].some(fn => fn(t));
export const getTypeOf = (t) => {
    if (t instanceof Map) {
        return 'Map';
    }
    if (t instanceof Set) {
        return 'Set';
    }
    if (t instanceof Function) {
        return 'Function';
    }
    if (t instanceof Object) {
        return getTypeOf(Object.values(t).filter(v => !isValid(v))[0]);
    }
    return typeof t;
};
//# sourceMappingURL=types.js.map